import React from 'react';
import './spinner.css';

class Spinner extends React.Component {
  render() {
    const styles = {
      borderColor: this.props.color ? this.props.color : '#FFF',
    };
    let cssClass = this.props.visible ? '' : 'hidden';
    if (this.props.relative === 'relative') {
      cssClass += ' relative';
    }
    return (
      <div id="global_spinner" className={cssClass}>
        <div className="relativatore">
          <div className="lds-ripple">
            <div style={styles}></div>
            <div style={styles}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Spinner;
